export default __webpack_public_path__ + "static/media/acms-aaa.8161869f.svg";